import * as React from 'react';
import { Button, ButtonStyle, IButtonProps } from '../../primitives/button/button';

export class BackButton extends React.Component<IButtonProps, {}> {
	render() {
		return (
			<Button
				{...this.props}
				className="button"
				buttonStyle={ButtonStyle.Text}
			/>
		);
	}
}
